import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getOrders } from "app/contexts/reducers/transaction/oderSlice";
import TableRowData from "./TableRowData";
import SearchAccount from "./SearchAccount";
import styled from "@emotion/styled";
import FilterOrderByMonth from "./FilterOrderByMonth";
import FilterStatus from "./FilterStatus";

const Title = styled("span")(() => ({
  fontSize: "1rem",
  fontWeight: "500",
  textTransform: "capitalize"
}));

const CardHeader = styled(Box)(() => ({
  display: "flex",
  paddingLeft: "24px",
  paddingRight: "24px",
  marginBottom: "12px",
  alignItems: "center",
  justifyContent: "space-between"
}));

const CollapsibleTable = ({ apiCall, setApiCall }) => {
  const { isOrderSuccess, ordersData } = useSelector((state) => state.order);

  const [orderData, setOrderData] = useState([]);
  const [filters, setFilters] = useState({
    status: 0, // Pending by default
    month: null, // No month filter by default (Select Month)
    year: null
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch, apiCall]);

  useEffect(() => {
    if (isOrderSuccess) {
      applyFilters();
    }
  }, [isOrderSuccess, ordersData, filters]);

  const applyFilters = () => {
    if (!ordersData?.data?.data) return;

    let filtered = [...ordersData.data.data];

    // --- Status Filter (4 = All status) ---
    if (filters.status !== 4) {
      filtered = filtered.filter(
        (order) => Number(order.status) === filters.status
      );
    }

    // --- Month-Year Filter ---
    if (filters.month && filters.year) {
      filtered = filtered.filter((order) => {
        const date = new Date(order.date);
        return (
          date.getMonth() + 1 === filters.month &&
          date.getFullYear() === filters.year
        );
      });
    }

    setOrderData(filtered);
  };

  // --- Group by account_id ---
  const groupedOrders = orderData.reduce((acc, order) => {
    const existingGroup = acc.find(
      (group) => group.accountId === order.account_id
    );

    if (existingGroup) {
      existingGroup.orders.push(order);
    } else {
      acc.push(createData(order.account_id, [order], order.account_name));
    }

    return acc;
  }, []);

  return (
    <Card elevation={3} sx={{ pt: "20px", mb: 3 }}>
      <CardHeader>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Title>OrderTable</Title>
          </Grid>
          <Grid item>
            <Grid container spacing={1}>
              <Grid item>
                <SearchAccount setOrderData={setOrderData} />
              </Grid>
              <Grid item>
                <FilterOrderByMonth setFilters={setFilters} filters={filters} />
              </Grid>
              <Grid item>
                <FilterStatus setFilters={setFilters} filters={filters} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardHeader>

      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead sx={{ backgroundColor: "rgb(34,41,67)" }}>
            <TableRow>
              <TableCell
                align="center"
                sx={{ px: 0, fontWeight: "bold", color: "#FFFFFF" }}
                colSpan={6}
              >
                Account Name
              </TableCell>
              <TableCell sx={{ width: "5%" }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {groupedOrders.map((group) => (
              <TableRowData
                key={group.accountId}
                row={group}
                setApiCall={setApiCall}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

function createData(accountId, orders, accountName) {
  return {
    accountId,
    orders,
    accountName
  };
}

export default CollapsibleTable;
